import React from 'react'
import PropTypes from 'prop-types'
import Select2 from 'components/atoms/Select2'

export default class SelectInput extends React.Component {
  constructor(props) {
    super(props)

    this.textValue = undefined
    this.handleSelect = this.handleSelect.bind(this)
    this.setSelect2Text = this.setSelect2Text.bind(this)
  }

  setSelect2Text(e) {
    this.textValue = e.target.options[e.target.selectedIndex].text
  }

  handleSelect(e) {
    this.props.handleChange(e)
    this.setSelect2Text(e)
  }

  render() {
    const {
      name,
      value,
      selectOptions,
      options,
      required,
      onChange,
    } = this.props

    return (
      <Select2
        name={name}
        value={value}
        data={selectOptions || []}
        onSelect={this.handleSelect}
        options={options}
        required={required}
        onChange={onChange}
      />
    )
  }
}

SelectInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectOptions: PropTypes.array,
  options: PropTypes.object,
  required: PropTypes.bool,
  handleChange: PropTypes.func,
  onChange: PropTypes.func,
}

SelectInput.defaultProps = {
  name: '',
  value: '',
  selectOptions: [],
  options: [],
  required: false,
  handleChange: () => {},
  onChange: () => {},
}
